import { render, staticRenderFns } from "./registrationDetails.vue?vue&type=template&id=1d947a7e&"
import script from "./registrationDetails.vue?vue&type=script&lang=js&"
export * from "./registrationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports